import { faBan, faBuilding, faUnlock, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import DashboardLayout from './DashboardLayout';

const AdminDashboard = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [validatedCompaniesCount, setValidatedCompaniesCount] = useState(0);
  const [validatedHrCount, setValidatedHrCount] = useState(0);
  const [hrCount, setHrCount] = useState(0);
  const [companyCount, setCompanyCount] = useState(0);
  const [combinedData, setCombinedData] = useState({
    labels: [],
    datasets: [
      {
        label: 'User %',
        backgroundColor: 'skyblue',
        borderColor: 'black',
        borderWidth: 1,
        hoverBackgroundColor: 'skyblue',
        hoverBorderColor: 'black',
        data: []
      },
      {
        label: 'Company %',
        backgroundColor: 'lightgreen',
        borderColor: 'black',
        borderWidth: 1,
        hoverBackgroundColor: 'lightgreen',
        hoverBorderColor: 'black',
        data: []
      }
    ]
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const hrResponse = await axios.get(`${BASE_API_URL}/countofHrs`);
      setHrCount(hrResponse.data);

      const companiesResponse = await axios.get(`${BASE_API_URL}/countOfCompanies`);
      setCompanyCount(companiesResponse.data);

      const validatedCompaniesResponse = await axios.get(`${BASE_API_URL}/countValidatedCompanies`);
      setValidatedCompaniesCount(validatedCompaniesResponse.data);

      const validatedHrResponse = await axios.get(`${BASE_API_URL}/countValidatedUsers`);
      setValidatedHrCount(validatedHrResponse.data);

      // const allMonths = [
      //   "January", "February", "March", "April", "May", "June",
      //   "July", "August", "September", "October", "November", "December"
      // ];

      // const userResponse = await axios.get(`${BASE_API_URL}/countValidateUsersByMonth`);
      // const userDataFromApi = allMonths.map((month, index) => userResponse.data[index + 1] || 0);

      // const companyResponse = await axios.get(`${BASE_API_URL}/countValidateCompaniesByMonth`);
      // const companyDataFromApi = allMonths.map((month, index) => companyResponse.data[index + 1] || 0);

      // setCombinedData({
      //   labels: allMonths,
      //   datasets: [
      //     {
      //       label: 'User %',
      //       backgroundColor: 'skyblue',
      //       borderColor: 'black',
      //       borderWidth: 1,
      //       hoverBackgroundColor: 'skyblue',
      //       hoverBorderColor: 'black',
      //       data: userDataFromApi
      //     },
      //     {
      //       label: 'Company %',
      //       backgroundColor: 'lightgreen',
      //       borderColor: 'black',
      //       borderWidth: 1,
      //       hoverBackgroundColor: 'lightgreen',
      //       hoverBorderColor: 'black',
      //       data: companyDataFromApi
      //     }
      //   ]
      // });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const toggleFullScreen = () => {
    if (document.fullscreenEnabled) {
      if (!document.fullscreenElement) document.documentElement.requestFullscreen();
      else document.exitFullscreen();
    }
  };

  const toggleSettings = () => {
    navigate('/');
  };
  const DATA = [
    { icon: faBuilding, title: validatedCompaniesCount, subtitle: "Validate Companies", link: "/admin-dashboard/add-company-details" },
    { icon: faUser, title: validatedHrCount, subtitle: "Validate Hrs", link: "/admin-dashboard/user-validation" },
    { icon: faUnlock, title: 'Access', subtitle: "HR & Candidate" },
    { icon: faBan, title: '15', subtitle: 'HR Blocked' }
  ];


  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 767);

  useEffect(() => {
    // Update the `isSmallScreen` state based on screen resizing
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 767);

    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    // <div className='dashboard-container'>
    //   <div className={`left-side ${isLeftSideVisible ? 'visible' : ''}`}>
    //     <AdminleftSide onClose={toggleLeftSide} />
    //   </div>
    <DashboardLayout>

      <div className="main-content">
        <Container className="my-dashboard-container">
          <h2 className='text-start' style={{ marginLeft: '12px' }}>Admin status</h2>
          <Row className="dashboard d-flex mt-4">
            {DATA.map((card, index) => (
              <Col lg={3} sm={6} key={index} >
                <Card className="card-icon-bg gap-3 card-icon-bg-primary o-hidden mb-4" style={{ maxWidth: '250px' }}>
                  <Card.Body className="align-items-center gap-4" >
                    <FontAwesomeIcon icon={card.icon} className="me-2 text-primary mb-0 text-24 fw-semibold" />
                    <div className="content gap-1">
                      {card.link ? (
                        <Link to={card.link} className="nav-link">
                          <p className="text-muted mb-0 text-capitalize">{card.subtitle}</p>
                          <p className="lead text-primary text-24 mb-0 text-capitalize">{card.title}</p>
                        </Link>
                      ) : (
                        <>
                          <p className="text-muted mb-0 text-capitalize">{card.subtitle}</p>
                          <p className="lead text-primary text-24 mb-0 text-capitalize">{card.title}</p>
                        </>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        <div className="applyforValidation">
          <span>
            <h4>Check for processing User validation!!</h4>
            <p>
              <Button>
                <Link
                  to="/admin-dashboard/admin-action"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/admin-dashboard/admin-action');
                  }}
                  style={{ color: 'white' }}
                >
                  Check
                </Link>
              </Button>
            </p>
          </span>
          <span>
            <h4>Add new content to the CMS panel:</h4>
            <p>
              <a
                href="http://51.79.18.21:1337/admin/auth/login"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <Button>
                  Add Content
                </Button>
              </a>
            </p>
          </span>
        </div>


      </div>

    </DashboardLayout>
  );
};

export default AdminDashboard;
